import type { TriageStatus } from '@/lib/inngest/functions/repo-scan/schemas';

/**
 * The codebase scan's name for each finding status, and the example feedback it
 * suggests when someone sets one. Other places that show a finding's status,
 * such as a dead-code DM's note of what someone set aside, use these so the
 * words match.
 */
export const TRIAGE_STATUS_LABELS: Record<TriageStatus, string> = {
  open: 'Open',
  in_review: 'In review',
  resolved: 'Resolved',
  false_positive: 'False positive',
  wont_fix: "Won't fix",
  intended_behavior: 'Intended Behavior',
  accepted_risk: 'Accepted risk',
};

export const TRIAGE_FEEDBACK_PLACEHOLDERS: Partial<Record<TriageStatus, string>> = {
  resolved: 'e.g., Fixed in PR #123, refactored the query...',
  false_positive: 'e.g., Not a real issue - this is test code...',
  wont_fix: 'e.g., Technical debt, not worth fixing right now...',
  intended_behavior: 'e.g., This behavior is intentional and documented...',
  accepted_risk: 'e.g., Risk acknowledged, acceptable for internal tool...',
};

/** The statuses that set a finding aside without fixing it, in the order the scan lists them. */
export const DISMISS_TRIAGE_STATUSES = [
  'false_positive',
  'wont_fix',
  'intended_behavior',
  'accepted_risk',
] as const satisfies readonly TriageStatus[];

export type DismissTriageStatus = (typeof DISMISS_TRIAGE_STATUSES)[number];

/** Whether a finding is set aside without fixing it. */
export function isDismissTriageStatus(status: string): status is DismissTriageStatus {
  return DISMISS_TRIAGE_STATUSES.some((candidate) => candidate === status);
}
